module.exports = __webpack_public_path__ + "img/mulish-v11-latin-italic.a378aed.svg";